export default {
    orders(orig) {
        return axios.get('/api/ecommerce/orders?orig='+orig);
    },
    ordersdetail(order_id) {
        return axios.get('/api/ecommerce/order/' + order_id);
    },
    payments(orig) {
        return axios.get('/api/ecommerce/payments?orig='+orig);
    },
    sendReceipt(order_id) {
        return axios.get('/api/ecommerce/order/' + order_id + '/sendreceipt');
    },
};
